import TasksPage from './TasksPage-redux';

export default TasksPage;
